import { Directive } from '@angular/core';
import { AbstractControl, AsyncValidator, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { UserDetailModel } from 'countable@model';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { FirmService } from '../services/firm.service';

export function UniqueEmailValidator(firmService: FirmService, authService: AuthService, toaster: ToastrService): AsyncValidatorFn {
  return (c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    let teamEditData: any;
    let teamEmail: string = null;
    let teamRole: number = null;
    const inputEmail = c.value;
    const user: UserDetailModel = authService.getUserDetail();
    // coming from team section
    if (localStorage.getItem('teamMemberData')) {
      teamEditData = JSON.parse((localStorage.getItem('teamMemberData')));
      teamEmail = teamEditData.emailaddress;
      teamRole = teamEditData.userroleid;
    }
    // coming from Settings > team access
    if (localStorage.getItem('settingsUserAccessTeamMemberData')) {
      teamEditData = JSON.parse((localStorage.getItem('settingsUserAccessTeamMemberData')));
      teamEmail = teamEditData.email;
      teamRole = teamEditData.useraccountroleid;
    }
    // coming from profile
    if (!teamEmail && localStorage.getItem('profile_email_validation') == '1') {
      teamEmail = user.emailAddress;
      teamRole = user.userroleId;
    }
    // if the login user is editing his own account
    if (teamEmail == inputEmail) {
      return of(null);
    }
    // if coming from this place, override role
    if (localStorage.getItem('addteamMemeberCat')) {
      teamRole = +localStorage.getItem('addteamMemeberCat');
    }
    // check the email format and exit if incorrect
    if (teamRole === 11) {
      if (!inputEmail.match(environment.EMAIL_REG_EXP_CMS)) {
        toaster.error('Please use an email address with the domain “Countable.co”');
        return of({'uniqueEmail': true});
      }
    } else {
      if (!inputEmail.match(environment.EMAIL_REG_EXP)) {
        toaster.error('Please use a valid email format');
        return of({'uniqueEmail': true});
      }
    }
    // call api
    return firmService.validateEmail(inputEmail, teamRole).pipe(
      map(res => {
        if (teamRole == 11) {
          if (res.data) {
            localStorage.setItem('uniqueMailValidateCMS', JSON.stringify(res.data));
          } else {
            localStorage.removeItem('uniqueMailValidateCMS');
          }
        }
        if (res.status !== 200) {
          toaster.error('Email Address already exists. Please use another email');
          return {'uniqueEmail': true};
        } else {
          return null;
        }
      }),
      catchError(() => {return of(null);})
    );
  };
}

@Directive({
  selector: '[uniqueEmail][formControlName],[uniqueEmail][formControl],[uniqueEmail][ngModel]',
  providers: [{provide: NG_ASYNC_VALIDATORS, useExisting: UniqueEmailValidatorDirective, multi: true}],
  standalone: true
})
export class UniqueEmailValidatorDirective implements AsyncValidator {
  constructor(private firmService: FirmService, private authService: AuthService, private toaster: ToastrService) { }

  validate(c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return UniqueEmailValidator(this.firmService, this.authService, this.toaster)(c);
  }
}
